import { Box, IconButton as MuiIconButton } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const LoadingWrapper = styled(Box)`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const IconButton = styled(MuiIconButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 4px;

  svg {
    width: 20px;
    height: 20px;
  }

  :hover {
    background: rgba(208, 195, 204, 0.15);
  }

  .is-pinned {
    background: ${theme.colors.textPrimary};
    border-color: ${theme.colors.controlBorder};
  }

  .is-disabled {
    cursor: inherit;
    border-color: ${theme.colors.controlBorder};
    background: rgba(227, 227, 227, 0.13);
  }
`
